export const ACTION_GET_VEHICLE_ONGOING_TRIP_PIN_CODE = '@fuelCard/ACTION_GET_VEHICLE_ONGOING_TRIP_PIN_CODE';
export const ACTION_SET_VEHICLE_ONGOING_TRIP_PIN_CODE_SUCCESS =
    '@fuelCard/ACTION_SET_VEHICLE_ONGOING_TRIP_PIN_CODE_SUCCESS';
export const ACTION_SET_VEHICLE_ONGOING_TRIP_PIN_CODE_ERROR =
    '@fuelCard/ACTION_SET_VEHICLE_ONGOING_TRIP_PIN_CODE_ERROR';
